export default __webpack_public_path__ + "static/media/Corpay x Alpha LockUp_Italian - Corporate - Horizontal - White.94f37bad.svg";